import AuditField from "./AuditField";

export default function BlocDirigeants({ dirigeants = [] }) {
 if (dirigeants.length === 0) {
 return (
 <section className="bg-surface p-6 rounded-xl shadow">
 <h2 className="text-xl font-bold text-primary">Dirigeants</h2>
 <p className="text-sm text-subtle">Aucun dirigeant enregistré.</p>
 </section>
 );
 }

 return (
 <section className="space-y-8 bg-surface p-6 rounded-xl shadow">
 <h2 className="text-xl font-bold text-primary">Dirigeants</h2>
 {dirigeants.map((dir, index) => (
 <div key={index} className="border-t pt-4 space-y-4">
 <h3 className="text-md font-semibold text-muted">Dirigeant {index + 1}</h3>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
 <AuditField label="Nom" value={dir.nom} />
 <AuditField label="Prénom" value={dir.prenom} />
 <AuditField label="Civilité" value={dir.civilite} />
 <AuditField label="Genre" value={dir.genre} />
 <AuditField label="Date de naissance" value={dir.dateNaissance?.slice(0, 10)} />
 <AuditField label="Lieu de naissance" value={dir.lieuNaissance} />
 <AuditField label="Nationalité" value={dir.nationalite} />
 <AuditField label="Email" value={dir.email} />
 <AuditField label="Téléphone" value={dir.telephone} />
 <AuditField label="Adresse" value={dir.adresse} />
 <AuditField label="Code postal" value={dir.codePostal} />
 <AuditField label="Ville" value={dir.ville} />
 <AuditField label="Pays" value={dir.pays} />
 <AuditField label="Fonction" value={dir.fonction} />
 <AuditField label="Type de mandat" value={dir.typeMandat} />
 <AuditField label="Date de prise de fonction" value={dir.datePriseFonction?.slice(0, 10)} />
 <AuditField label="Date de fin de mandat" value={dir.dateFinMandat?.slice(0, 10)} />
 <AuditField label="% Capital" value={`${dir.pourcentageCapital ?? 0} %`} />
 <AuditField label="% Droits de vote" value={`${dir.pourcentageDroitsVote ?? 0} %`} />
 <AuditField label="Bénéficiaire effectif" value={dir.beneficiaireEffectif ? "Oui" : "Non"} />
 <AuditField label="Statut KYC" value={dir.kycStatus} />
 <AuditField label="PEP" value={dir.pep ? "Oui" : "Non"} />
 <AuditField label="Document identité" value={dir.documentIdentite} />
 <AuditField label="Justificatif domicile" value={dir.justificatifDomicile} />
 <AuditField label="Remarque" value={dir.remarque} />
 </div>
 </div>
 ))}
 </section>
 );
}
